import { useParams } from "react-router-dom";
const Intro = () => {
    const { lang } = useParams();
    let reasons = [
        "Easy to use interface",
        "Customer centric",
        "Feature rich",
        "Stable",
        "Free version",
        "Add-ons to extend functionality",
        "Paid plans to support business growth",
    ];

    let receiptPrintingDetails = [
        "Print company logo",
        "Custom header",
        "Custom footer and thank you note",
        "Translate and customize receipt",
    ];

    let inventoryDetails = [
        "Simplified stock management",
        "Organize your products into groups",
        "Search by barcode, SKU or product name",
        "View items on hand",
        "Product history",
        "Inventory counts and stock adjustments",
    ]

    const stats = [
        { id: 1, name: 'Downloads', value: '1M+' },
        { id: 2, name: 'Monthly active users', value: '50K+' },
        { id: 3, name: 'Countries', value: '140+' },
    ]

    return (
        <>
            <section className="p-4 my-10">
                <div className="p-8 max-w-screen-xl mx-auto md:grid md:grid-cols-5 gap-4 rounded-[20px] bg-slate-200 md:flex md:items-center md:justify-center">
                    <div className="col-span-2 md:px-4 mb-8 md:mb-0">
                        <h2 className="text-4xl mb-4 inline-block align-middle">Why Aronium?</h2>
                        <p>Powerful. Simple. Flexible. Aronium offers everything you need to manage your business efficiently – from user-friendly interfaces to robust features, whether you're a small shop or a growing enterprise.</p>
                        <ul className="space-y-1 list-inside mt-4">
                            {
                                reasons.map((item, index) => (
                                    <li key={index} className="flex items-center">
                                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" fill="currentColor" className="w-6 h-6 mx-2 text-blue-500"><path d="M24 6.278l-11.16 12.722-6.84-6 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.278zm-22.681 5.232l6.835 6.01-1.314 1.48-6.84-6 1.319-1.49zm9.278.218l5.921-6.728 1.482 1.285-5.921 6.756-1.482-1.313z" /></svg>
                                        {item}
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <img className="md:col-span-3" src={`${process.env.PUBLIC_URL}/images/hero-image.png`} alt="Aronium POS system" />
                </div>
            </section>

            <section className="max-w-screen-xl px-4 mx-auto my-10">
                <div className="grid sm:grid-cols-2 gap-4">
                    <div>
                        <h1 className="font-medium text-lg">Receipt printing</h1>
                        <p className="text-sm text-slate-700 py-4">Compatible with all major printers including Epson, Posiflex and more.<br />Print on standard Windows or ESC/POS compatible printers.</p>

                        <ul className="space-y-1 list-inside mt-2">
                            {
                                receiptPrintingDetails.map((item, index) => (
                                    <li key={index} className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-green-700 mr-2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                        {item}
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div>
                        <h1 className="font-medium text-lg">Inventory management</h1>
                        <p className="text-sm text-slate-700 py-4">Keep your eyes on the stock levels! Easy manage and see stock breakdowns.<br />Perform quick inventory counts for any stock level adjustments.</p>

                        <ul className="space-y-1 list-inside mt-2">
                            {
                                inventoryDetails.map((item, index) => (
                                    <li key={index} className="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 text-green-700 mr-2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>

                                        {item}
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
                <div className="text-center mt-10">
                    <a href={`/${lang}/features`} className="hover:no-underline text-slate-800 px-6 py-2 inline-flex text-base font-medium text-center text-gray-900 border border-gray-300 transition-colors duration-300 rounded-full hover:bg-gray-100 focus:ring-4 focus:ring-gray-100">
                        Explore more features <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="ml-2 w-6 h-6 transition-all">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                        </svg>
                    </a>
                </div>
            </section>

            <section className="relative w-full overflow-hidden px-4 bg-blue-600 text-white">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500 via-indigo-500 to-pink-400 opacity-80 blur-3xl"></div>
                <div className="relative z-10 mx-auto max-w-screen-xl">

                    <div className="text-center my-24 mx-4">
                        <h1 className="text-5xl mb-4">Focus on your business — not the app.</h1>
                        <h3>An intuitive Point of Sale application designed to simplify sales, reduce clicks, and let you get back to what matters.</h3>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4 pb-32">
                        {/* Text Content */}
                        <div className="flex flex-col justify-center">
                            <h1 className="text-3xl font-semibold">Grow smarter!</h1>
                            <p className="mt-5 text-base leading-relaxed">
                                Aronium simplifies business management with an intuitive design and powerful tools that adapt to your needs, helping you focus on growth and customer satisfaction.
                            </p>

                            <h2 className="text-3xl font-semibold mt-10">Stay ahead!</h2>
                            <p className="mt-5 text-base leading-relaxed">
                                Streamline your daily operations, reduce complexity, and ensure your business stays ahead with Aronium's reliable and feature-rich platform.
                            </p>

                            <h2 className="text-3xl font-semibold mt-10">Built for you!</h2>
                            <p className="mt-5 text-base leading-relaxed">
                                Tailored to your unique business needs, Aronium combines simplicity and innovation to give you a POS system that grows with you.
                            </p>
                        </div>
                        <div className="sm:w-auto md:w-[70rem]">
                            <img alt="Aronium sales screen" fetchpriority="high" width="2174" height="1464" decoding="async" data-nimg="1" className="w-full rounded-md drop-shadow-2xl border-4 border-white" sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem" src={`${process.env.PUBLIC_URL}/images/main-sales-screen.png`} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="mt-20 px-4 overflow-hidden mx-auto max-w-screen-xl">
                <div className="flex flex-col text-center mb-10">
                    <h1 className="text-3xl">Analytics dashboard</h1>
                    <p className="mt-5">Track sales and item statistics in real-time. Analyze your sales, best selling items, customers and discounts easily and in one place.</p>
                    <p>Use advantages of build-in daily reports to spend your time as efficiently as possible.</p>
                </div>
                <div className="grid place-content-center justify-items-center">
                    <img src={`${process.env.PUBLIC_URL}/images/management-dashboard.png`} className="rounded-t-lg border-t-8 border-r-8 border-l-8 border-slate-700" alt="Sales screen" />
                </div>
            </section>

            <section className="bg-gradient-to-r from-cyan-500 to-blue-500 py-20 mt-0">
                <div className="text-white max-w-screen-xl p-4 mx-auto text-center">
                    <h1 className="text-white text-5xl">Get started today</h1>
                    <div className="my-10 text-lg">Your new sales experience starts here</div>
                    <a href={`/${lang}/download`} className="hover:no-underline rounded-full px-5 py-3 text-gray-900 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 text-sm font-medium">
                        Download now
                    </a>
                </div>
            </section>

            <section className="py-24">
                <div className="p-4 text-center">
                    <h1 className="text-3xl md:text-5xl">Trusted by customers worldwide</h1>
                    <p className="my-5 text-lg">Try it now! Thousands of loyal customers can't be wrong.</p>

                    <div className="py-24 mx-auto max-w-screen-xl text-center grid grid-cols-1 md:grid-cols-3 md:divide-x md:divide-solid md:divide-sky-500 gap-x-8 gap-y-16">
                        {stats.map((stat) => (
                            <div key={stat.id}>
                                <div className="order-first text-3xl font-light tracking-tight text-cyan-500 sm:text-5xl">
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-700 to-cyan-500">{stat.value}</span>
                                </div>
                                <div className="text-base/7 text-gray-700">{stat.name}</div>
                            </div>
                        ))}
                    </div>

                    <p className="my-5 text-2xl font-normal">Aronium is used in <span className="font-medium text-cyan-600">more than 140 countries</span> every day.</p>
                    <div className="grid place-content-center justify-items-center mt-10">
                        <a
                            href="https://www.google.com/maps/d/viewer?mid=1tfVp_DyzJ4K7icwZPXvy-syhYRM&ll=11.65724374980218%2C34.269597999999974&z=2"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Click the map to see country list"
                            data-analytics-event="map"
                        >
                            <img src={`${process.env.PUBLIC_URL}/images/world-map.png`} alt="Aronium worldwide" className="w-2/3 mx-auto"></img>
                        </a>
                    </div>
                </div>
            </section >

            <section className="py-20 bg-slate-50">
                <div className="p-4 text-center">
                    <h1 className="text-3xl">Made for Windows</h1>
                    <p className="my-5">Aronium is built as a native Windows application and it is compatible with all major Windows versions.</p>
                    <div className="grid place-content-center">
                        <img src={`${process.env.PUBLIC_URL}/images/windows-compatibility.png`} className="aspect-auto" alt="Compatible with all major Windows versions"></img>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Intro;